
<template>
    <!-- 提交中标结果 -->
    <el-dialog title="提交委托信息" :visible.sync="showDialog">
        <el-form :model="dataForm" ref="refDataForm"  :rules="rules"  size="small" label-width="100px">
            <el-form-item label="定损员姓名" prop="insuranceCompanyName">
                <el-input v-model="dataForm.insuranceCompanyName"></el-input>
            </el-form-item>

            <el-form-item label="定损员电话" prop="insuranceCompanyPhone">
                <el-input v-model="dataForm.insuranceCompanyPhone"></el-input>
            </el-form-item>
            
            <el-form-item label="车主姓名" prop="vehicleOwnerName">    
                <el-input v-model="dataForm.vehicleOwnerName"></el-input>
            </el-form-item>

            <el-form-item label="车主电话" prop="vehicleOwnerPhone">
                <el-input v-model="dataForm.vehicleOwnerPhone"></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
                <el-input type="textarea" v-model="dataForm.remark">

                </el-input>
            </el-form-item>
            
            <el-form-item>
                <el-button type="success" @click="handleValidate" >提交</el-button>
                <el-button type="danger" @click="showDialog=false">关闭</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
    import {addupdateVehicleEntrust} from '@/api/vehicle/case'
    export default {
        props:{
            showStatus: {
                type: [Boolean],
                default:false
            },
            //案件对象详细信息
            caseObj:{
                type:Object,
            }
        },
      
        computed: {  
            // 创建一个计算属性，它依赖于prop的值  
            showDialog:{  
                // 在这里你可以根据propData的值进行计算或者修改  
                get() {  
                    return this.showStatus;
                },
                set(newValue) {  
                    // 更新对话框的显示状态  
                    this.$emit('close');
                }   
            },
        },  
        watch: {  
            caseObj(newValue, oldValue) {
                this.dataForm={};
                this.dataForm.caseId=newValue.caseId;  
                // this.dataForm.caseSn=newValue.caseSn;
            }
        }, 
         
        data(){
            return{
                dataForm:{
                    caseId:0,
                    insuranceCompanyPhone:"",
                    insuranceCompanyName:"",
                    vehicleOwnerName:"",
                    vehicleOwnerPhone:'',
                    remark:'',
                },
                rules: {
                    insuranceWorkerPhone: [
                        { required: true, message: '定损员电话不能为空', trigger: 'blur' },
                    ],
                    insuranceWorkerName: [
                        { required: true, message: '定损员姓名不能为空', trigger: 'blur' },
                    ],
                    vehicleOwnerName: [
                        { required: true, message: '车主姓名不能为空', trigger: 'blur' },
                    ],
                    vehicleOwnerPhone: [
                        { required: true, message: '车主电话不能为空', trigger: 'blur' },
                    ],
                } 
            }
        },
        methods:{
            //提交,提交成功，则提示并且关闭；提交失败，提示不关闭
            handleValidate(){
               this.$refs['refDataForm'].validate((valid) => {
                // 直接提交    
                if(valid){
                    this.handleSubmit();
                }else{
                    //提示信息，是否报错
                    this.$confirm('部分信息不完善, 是否继续保存?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).then(() => {
                            this.handleSubmit();
                        }).catch(() => {
                                 
                        });
                }

               }) 
            },

            handleSubmit(){
                addupdateVehicleEntrust(this.dataForm).then(res=>{
                    if(res.success){
                        this.$message.success("提交成功");
                        this.showDialog=false;
                    }else{
                        this.$message.error("提交失败");
                    }
                })
            },
        }
    }
</script>